import { useMutation, useQueryClient } from '@tanstack/react-query';

import { fetchRefreshMyDosespotClinicianInfo } from '../api/refreshMyDosespotClinicianInfo.js';
import { dosespotClinicianKeys } from './keys.js';

export function useRefreshMyDosespotClinicianInfoMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['dosespot-clinician', 'refresh-me'],
    mutationFn: async () => {
      return await fetchRefreshMyDosespotClinicianInfo();
    },
    onSuccess: () => {
      // Invalidate my clinician info and registration status after refresh
      queryClient.invalidateQueries({ queryKey: dosespotClinicianKeys.myInfo() });
      queryClient.invalidateQueries({ queryKey: dosespotClinicianKeys.myRegistrationStatus() });
    },
  });
}
